import React from "react";

/**
 * EISG official lockup (text-only — no icon).
 *
 * - "EISG" wordmark (Playfair Display, bold, gold accent line)
 * - Subtitle "Institut Exécutif de Stratégie et de Gouvernance"
 * - Caption "Une division de BridgeDatum"
 *
 * Variants:
 *   - "full"    → hero / footer / formal sections
 *   - "compact" → navbar / header
 *   - "stack"   → centered stacked badge
 *
 * Tones:
 *   - "light"   → for dark backgrounds (white + gold)
 *   - "dark"    → for light backgrounds (navy + gold)
 */

const EISGLogo = ({ variant = "full", tone = "light", className = "" }) => {
  const isLight = tone === "light";
  const primaryText = isLight ? "text-white" : "text-[#0A192F]";
  const subText = isLight ? "text-white/75" : "text-[#0A192F]/75";
  const captionText = "text-[#D4AF37]";
  const ruleBg = isLight ? "bg-[#D4AF37]" : "bg-[#D4AF37]";

  if (variant === "compact") {
    return (
      <div className={`flex flex-col leading-tight ${className}`}>
        <div className="flex items-center gap-3">
          <span className={`font-eisg text-3xl sm:text-[32px] font-bold tracking-[0.06em] ${primaryText}`}>
            EISG
          </span>
          <span className={`h-6 w-px ${isLight ? "bg-white/25" : "bg-[#0A192F]/20"}`} />
          <span className={`text-[10px] sm:text-[11px] tracking-[0.24em] uppercase font-bold ${captionText}`}>
            Une division<br />de BridgeDatum
          </span>
        </div>
      </div>
    );
  }

  if (variant === "stack") {
    return (
      <div className={`flex flex-col items-center text-center ${className}`}>
        <div className={`font-eisg text-6xl font-bold tracking-[0.06em] ${primaryText}`}>EISG</div>
        <div className={`mt-4 h-[2px] w-16 ${ruleBg}`} />
        <div className={`mt-5 text-sm tracking-[0.2em] uppercase font-semibold ${subText} max-w-md`}>
          Institut Exécutif de Stratégie<br />et de Gouvernance
        </div>
        <div className={`mt-4 text-[11px] tracking-[0.3em] uppercase font-bold ${captionText}`}>
          Une division de BridgeDatum
        </div>
      </div>
    );
  }

  // FULL — for hero / footer
  return (
    <div className={`flex flex-col ${className}`}>
      <div className={`font-eisg text-6xl sm:text-7xl font-bold tracking-[0.05em] leading-none ${primaryText}`}>
        EISG
      </div>
      <div className={`mt-4 h-[2px] w-14 ${ruleBg}`} />
      <div className={`mt-4 text-[12px] sm:text-[13px] tracking-[0.22em] uppercase font-bold ${subText} max-w-sm leading-relaxed`}>
        Institut Exécutif de Stratégie<br />et de Gouvernance
      </div>
      <div className={`mt-3 text-[10.5px] tracking-[0.3em] uppercase font-bold ${captionText}`}>
        Une division de BridgeDatum
      </div>
    </div>
  );
};

export default EISGLogo;
